export var DEFAULT_SHARE_ICON = 'share alternate';
export var DEFAULT_SUCCESS_MESSAGE = 'Success.';
export var DEFAULT_FAILURE_MESSAGE = 'Failed.';
export var FEEDBACK_POPUP_DURATION = 2000;
export var FEEDBACK_POPUP_CLASS = 'share-button-feedback';